import { normalizeBreakoutRoomsSaga } from 'features/breakout-rooms/sagas/normalizeBreakoutRoomsSaga';
import { call } from 'redux-saga/effects';
import { signalingBreakoutRoomsCreated } from 'features/breakout-rooms/actions';

export function* onBreakoutRoomCreatedSaga(
  action: ReturnType<typeof signalingBreakoutRoomsCreated>
) {
  yield call(normalizeBreakoutRoomsSaga, { rooms: action.payload.rooms });
}
